export const SETTINGS_PERMISSION_RESOURCES = [
  {
    name: '权限管理',
    code: 'permission',
    type: 'MENU',
    description: '控制应用权限管理页面访问',
    actions: [{ name: 'view', description: '查看' }],
  },
  {
    name: '模型设置',
    code: 'model-settings',
    type: 'MENU',
    description: '控制模型设置页面访问和模型绑定操作',
    actions: [
      { name: 'view', description: '查看' },
      { name: 'query', description: '查询' },
      { name: 'save', description: '保存' },
    ],
  },
] as const;
